import React from 'react'
import ChartJS, {
  IChartJSProps
} from '../../../components/common/charts/ChartJS'
import Chart from 'chart.js'
import dayjs from 'shared/dayjs'

interface IAnalyticsHourChartProps extends IChartJSProps {
  config: Chart.ChartConfiguration
  data: any[]
}

function buildHourlyChartJSData(data: Array<{ hour: number; count: number }>) {
  const graphData = {
    data: [],
    borderWidth: 1,
    stepped: true,
    pointRadius: 0,
    lineTension: 0,
    borderColor: 'rgba(75, 143, 226, 1)',
    backgroundColor: 'rgba(75, 143, 226, 1)'
  }

  // Filling missing data in
  const chartData = []
  ;[...Array(24).keys()].forEach((hour) => {
    const hourData = data.find((eachHourData) => eachHourData.hour === hour)
    if (hourData) {
      // @ts-expect-error 9/11/2020
      chartData.push(hourData)
    } else {
      chartData.push({
        // @ts-expect-error 9/11/2020
        count: 0,
        // @ts-expect-error 9/11/2020
        hour
      })
    }
  })

  // Build labels for every third hour
  const labels = chartData.map((hourData) => {
    // @ts-expect-error 9/11/2020
    return dayjs().set('hours', hourData.hour).format('ha')
  })

  chartData.forEach((hourData) => {
    // @ts-expect-error 9/11/2020
    graphData.data.push(hourData.count)
  })

  return {
    labels,
    datasets: [graphData],
    noData: !data.length
  }
}

const AnalyticsHourChart = ({
  data,
  config,
  ...props
}: IAnalyticsHourChartProps) => {
  config.data = buildHourlyChartJSData(data)

  return <ChartJS {...props} config={config} />
}

export default AnalyticsHourChart
